import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#FBF7EF] text-[#073C2F]">
      <Navbar />
      <main className="mx-auto max-w-4xl px-4 py-12 sm:px-6 md:px-10 md:py-16">
        <div className="rounded-lg border-[3px] border-retro-ink bg-white p-5 shadow-[8px_8px_0_#111111] sm:p-7 md:p-10">
          <p className="font-body text-sm font-black uppercase tracking-[0.2em] text-[#8B5B2B]">Note Console</p>
          <h1 className="mt-3 font-heading text-3xl uppercase leading-tight sm:text-5xl">Terms & Conditions</h1>
          <p className="mt-4 font-body text-sm font-semibold leading-7 text-[#073C2F]/76">
            Please read these terms before placing an order. By ordering Note Console, you agree to the terms below.
          </p>

          <div className="mt-8 grid gap-5 font-body text-sm leading-7 text-[#073C2F]/82">
            <TermBlock title="Pricing, GST, and Delivery">
              Prices shown on the website are product prices. GST may be added at checkout where applicable. Free delivery is available for now as part of the launch offer.
            </TermBlock>

            <TermBlock title="No Refund Policy">
              All orders are final. We do not offer refunds after an order is placed. If there is a genuine issue with delivery or a damaged product, contact us and we will review it case by case.
            </TermBlock>

            <TermBlock title="Order and Payment">
              Orders are completed through the payment checkout page. Please choose the correct plan at checkout before making payment.
            </TermBlock>

            <TermBlock title="Data We Collect">
              We may collect details such as your name, email, order option, coupon code, payment status, delivery information, and Order Now click activity.
            </TermBlock>

            <TermBlock title="How We Use Data">
              We use this data to process orders, arrange delivery, provide support, prevent misuse, understand which plans users prefer, improve Note Console, and share relevant launch updates or offers.
            </TermBlock>

            <TermBlock title="Privacy">
              We do not sell your personal data. Admin access to order and click details is restricted to the authorized Note Console admin account.
            </TermBlock>
          </div>

          <Link to="/" className="retro-btn mt-8 inline-flex bg-retro-yellow px-5 py-3 font-body text-sm font-black uppercase text-retro-ink">
            Back to Website
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function TermBlock({ title, children }) {
  return (
    <section className="rounded-lg border-2 border-[#D5AD76] bg-[#FBF7EF] p-4">
      <h2 className="font-heading text-xl uppercase text-[#073C2F]">{title}</h2>
      <p className="mt-2">{children}</p>
    </section>
  );
}
